<app-modal-container
  [formGroup]="teamMemberForm"
  [title]="this.user?.id ? 'Edit member' : 'Create member'"
  [buttons]="modalButtons"
  [applyActivated]="teamMemberForm.valid"
  [spinnerProps]="spinnerProps"
  (applyButtonClicked)="confirm()"
  (closeButtonClicked)="close(false)"
  (dismissButtonClicked)="close(false)"
  (upperRight1ButtonClicked)="resendInvite()"
  (lowerLeftButtonClicked)="deleteButtonClicked()">
  <div class="vertical-container-simple column-gap-1">
    <div class="row-container row-gap-1 grid-3rows" *ngVar="teamMemberForm.controls as form">
      <!--Name-->
      <app-input
        data-qa="employee-name"
        formControlName="name"
        [required]="true"
        [title]="'First name'"
        [placeholder]="'First name'"
        [inputID]="'name'"
        [additionalClass]="form.name.errors ? 'error' : ''">
      </app-input>
      <!--Workplace-->
      <app-input
        data-qa="employee-workplace"
        formControlName="companyName"
        [title]="'Workplace'"
        [placeholder]="'Workplace'"
        [inputID]="'workplace'"
        [additionalClass]="isKpi ? 'disabled': '' ">
      </app-input>
      <!--Email-->
      <app-input
        data-qa="employee-email"
        formControlName="mail"
        [required]="true"
        [title]="'Email'"
        [placeholder]="'Email'"
        [inputID]="'email'"
        [additionalClass]="form?.mail?.errors ? 'error' : ''"
        (inputChange)="teamMemberForm.patchValue({ mail: $event.toLowerCase()})">
      </app-input>
      <!--Last name-->
      <app-input
        data-qa="employee-surname"
        formControlName="family"
        [title]="'Last name'"
        [placeholder]="'Last name'"
        [inputID]="'lastName'">
      </app-input>
      <!--Position-->
      <app-input-autocomplete
        data-qa="employee-position"
        formControlName="position"
        [title]="'Position'"
        [data]="positions"
        [selectedObject]="positions ? this.user?.position : null"
        [inputID]="'position'">
      </app-input-autocomplete>
      <!--Phone-->
      <app-input
        data-qa="employee-phone"
        formControlName="phone"
        [title]="'Phone'"
        [placeholder]="'Phone'"
        [regularExpression]="regexpService.phoneOrEmpty"
        [inputID]="'phone'">
      </app-input>
    </div>
  </div>
  <ng-container *ngIf="!isKpi">
    <div class="whitespace-1"></div>
    <div class="bg-black-1 start-column-container row-gap-1 column-gap-1 padding-1 br-1">
      <div class="start-column-container column-gap-1">
        <div class="centered-row-container">
          <app-all-icons [iconNameAndStyling]="'lock-closed-fill.svg; icon-size-1p5'"></app-all-icons>
          <span class="font-2 bold500">Software access</span>
        </div>
        <!--Org Admin-->
        <app-checkbox
          *ngIf="(orgAccesses.isOrganizationAdmin || orgAccesses.isSuperAdmin)"
          data-qa="employee-org-admin"
          class="font-3 bold500"
          formControlName="organizationAdmin"
          (change)="toggleOrgAdmin(teamMemberForm.getRawValue().organizationAdmin, false)">
          Organization admin (Manages users & organization entities)
        </app-checkbox>
        <div class="row-container row-gap-1">
          <div class="vertical-container-simple column-gap-1">
            <!--Fund Performance-->
            <app-selector
              data-qa="employee-fund-performance"
              [title]="'Fund performance'"
              [data]="adminOrViewerOrNoAccessRoles"
              [field]="'displayRole'"
              [disabled]="teamMemberForm.controls.accessLevel.disabled"
              [selectedItem]="currentRoles[teamMemberForm.getRawValue().accessLevel ?? 'No Access']"
              [isNotInTable]="true"
              (itemEmitter)="teamMemberForm.patchValue({accessLevel: $event.role})">
            </app-selector>
            <!--PDF report generator-->
            <app-selector
              data-qa="employee-pdf"
              [data]="adminOrNoAccessRoles"
              [field]="'displayRole'"
              [disabled]="teamMemberForm.controls.portalPdf.disabled"
              [title]="'PDF report generator'"
              [selectedItem]="currentRoles[teamMemberForm.controls.portalPdf.value ? 'Admin' : 'No Access']"
              [isNotInTable]="true"
              (itemEmitter)="teamMemberForm.patchValue({portalPdf: hasPDFAccess($event.role) })">
            </app-selector>
          </div>
          <div class="vertical-container-simple column-gap-1">
            <!--Investor Portal-->
            <app-selector
              data-qa="employee-investor-portal"
              [title]="'Investor portal'"
              [data]="adminOrNoAccessRoles"
              [field]="'displayRole'"
              [disabled]="teamMemberForm.controls.portalAdminAccess.disabled"
              [selectedItem]="teamMemberForm.getRawValue().portalAdminAccess ? currentRoles['Admin'] : currentRoles['No Access']"
              [isNotInTable]="true"
              (itemEmitter)="updatePortalAccess($event.role)">
            </app-selector>
            <!--Market Analysis-->
            <app-selector
              data-qa="employee-market-analysis"
              [title]="'Market analysis'"
              [data]="viewerOrNoAccessRoles"
              [field]="'displayRole'"
              [disabled]="teamMemberForm.controls.marketAnalysis.disabled"
              [selectedItem]="teamMemberForm.getRawValue().marketAnalysis ? currentRoles['Viewer'] : currentRoles['No Access']"
              [isNotInTable]="true"
              (itemEmitter)="teamMemberForm.patchValue({marketAnalysis: hasMarketAnalysisAccess($event.role)})">
            </app-selector>
          </div>
          <div class="vertical-container-simple column-gap-1">
            <app-selector
              data-qa="employee-kpi-access"
              [title]="'Peformance KPIs'"
              [data]="adminOrViewerOrNoAccessRoles"
              [field]="'displayRole'"
              [disabled]="teamMemberForm.controls.kpiAccessLevel.disabled"
              [selectedItem]="currentRoles[teamMemberForm.getRawValue().kpiAccessLevel ?? 'No Access']"
              [isNotInTable]="true"
              (itemEmitter)="teamMemberForm.patchValue({kpiAccessLevel: $event.role})">
            </app-selector>
            <!--Financial Statements-->
            <app-selector
              data-qa="employee-financial-statements"
              [title]="'Financial statements'"
              [data]="adminOrViewerOrNoAccessRoles"
              [field]="'displayRole'"
              [disabled]="teamMemberForm.controls.financialStatementAccessLevel.disabled"
              [selectedItem]="currentRoles[teamMemberForm.getRawValue().financialStatementAccessLevel ?? 'No Access']"
              [isNotInTable]="true"
              (itemEmitter)="teamMemberForm.patchValue({financialStatementAccessLevel: $event.role})">
            </app-selector>
          </div>
          <div class="vertical-container-simple column-gap-1">
            <!--Data Room-->
            <app-selector
              data-qa="employee-data-room"
              [title]="'Data Room'"
              [data]="adminOrNoAccessRoles"
              [field]="'displayRole'"
              [disabled]="teamMemberForm.controls.dataRoomAccess.disabled"
              [selectedItem]="teamMemberForm.getRawValue().dataRoomAccess ? currentRoles['Admin'] : currentRoles['No Access']"
              [isNotInTable]="true"
              (itemEmitter)="teamMemberForm.patchValue({dataRoomAccess: hasDataRoomAccess($event.role) })">
            </app-selector>
          </div>
        </div>
      </div>
      <div class="black-line width-100pcnt"></div>
      <div class="start-column-container column-gap-1 width-100pcnt">
        <div class="centered-row-container">
          <app-all-icons [iconNameAndStyling]="'bell.svg; icon-size-1p5'"></app-all-icons>
          <span class="font-2 bold500">Notifications</span>
        </div>
        <div class="flex width-100pcnt">
          <!--Document uploaded-->
          <app-checkbox
            data-qa="employee-documents-uploaded"
            class="width-50pcnt font-3 bold500"
            formControlName="portfolioNotification">
            Documents uploaded
          </app-checkbox>
          <!--KPI submitted-->
          <app-checkbox
            data-qa="employee-kpi-submitted"
            class="font-3 bold500"
            formControlName="kpiNotification">
            KPI submitted
          </app-checkbox>
        </div>

      </div>
    </div>
  </ng-container>
</app-modal-container>

<app-modal-dialog
  *ngIf="showDeleteEmployeeModal"
  [header]="'Delete member'"
  [useStandardList]="false"
  [mainText]="deleteMemberTextList"
  [addAdditionalText]="true"
  (isConfirmed)="deleteTeamMember($event)">
</app-modal-dialog>
